import { createSelector } from '@reduxjs/toolkit';
import { getWidgetUiState } from './getWidgetUiState';
export const getIsIOSMobile = createSelector([getWidgetUiState], widgetUiState => {
  return widgetUiState.isIOSMobile;
});